export default __webpack_public_path__ + "static/media/Snd_ClowerI.c0da9377.mp3";